import { BufferEmptyError } from '#common/types';
export class CircularBuffer {
    buffer;
    head = 0;
    tail = 0;
    size = 0;
    constructor(maxSize) {
        if (maxSize <= 0) {
            throw new RangeError('Max size must be greater than 0');
        }
        this.buffer = new Array(maxSize);
    }
    get length() {
        return this.size;
    }
    isEmpty() {
        return this.size === 0;
    }
    isFull() {
        return this.size === this.buffer.length;
    }
    first() {
        this.throwIfEmpty();
        return this.buffer[this.tail];
    }
    last() {
        this.throwIfEmpty();
        return this.buffer[this.head];
    }
    get(index) {
        this.throwIfIndexOutOfBounds(index);
        return this.buffer[this.advanceIndex(this.tail, index)];
    }
    set(index, value) {
        this.throwIfIndexOutOfBounds(index);
        this.buffer[this.advanceIndex(this.tail, index)] = value;
    }
    push(value) {
        if (!this.isEmpty()) {
            this.head = this.advanceIndex(this.head);
        }
        this.buffer[this.head] = value;
        if (this.isFull()) {
            this.tail = this.advanceIndex(this.tail);
        }
        else {
            ++this.size;
        }
    }
    shift() {
        const value = this.first();
        this.buffer[this.tail] = undefined;
        this.tail = this.advanceIndex(this.tail);
        --this.size;
        return value;
    }
    pop() {
        const value = this.last();
        this.buffer[this.head] = undefined;
        this.head = this.retreatIndex(this.head);
        --this.size;
        return value;
    }
    clear() {
        this.buffer = new Array(this.buffer.length);
        this.head = 0;
        this.tail = 0;
        this.size = 0;
    }
    toArray() {
        const array = new Array(this.size);
        for (let i = 0; i < array.length; i++) {
            const index = this.advanceIndex(this.tail, i);
            array[i] = this.buffer[index];
        }
        return array;
    }
    forEach(callback) {
        for (let i = 0; i < this.size; i++) {
            const index = this.advanceIndex(this.tail, i);
            callback(this.buffer[index], index, this.buffer);
        }
    }
    *[Symbol.iterator]() {
        for (let i = 0; i < this.size; i++) {
            const index = this.advanceIndex(this.tail, i);
            yield this.buffer[index];
        }
    }
    advanceIndex(index, increment = 1) {
        return (index + increment) % this.buffer.length;
    }
    retreatIndex(index, decrement = 1) {
        return (((index - decrement) % this.buffer.length) + this.buffer.length) % this.buffer.length;
    }
    throwIfEmpty() {
        if (this.isEmpty()) {
            throw new BufferEmptyError();
        }
    }
    throwIfIndexOutOfBounds(index) {
        if (index < 0 || index >= this.size) {
            throw new RangeError('Index out of bounds');
        }
    }
}
